import { AssetDto, DocumentTypeDto } from '@ellf/common-dto';

export const validateAssets = (
  assets: AssetDto[],
  mandatoryDocTypes: (DocumentTypeDto | undefined)[]
): (AssetDto & { isValid: boolean })[] => {
  const res: (AssetDto & { isValid: boolean })[] = assets.map((a) => {
    let isValid = true;
    mandatoryDocTypes.forEach((tt) => {
      if (
        !(a.documents || []).find((dd) => dd.documentType?.code == tt?.code)
      ) {
        isValid = false;
      }
    });
    // isValid = isValid && !!a.insertDate;
    isValid = isValid && !!a.sicCode;
    // isValid = isValid && !!a.serialNumber;
    // isValid = isValid && !!a.modelDescription;
    // isValid = isValid && !!a.assetType;
    // isValid = isValid && !(a.warrantyMonths === undefined);
    // isValid = isValid && !!a.endWarrantyDate;
    // isValid = isValid && !!a.manufacturer;
    // isValid = isValid && !(a.economicValue === undefined);
    // isValid = isValid && !(a.spareAsset === undefined);
    // isValid = isValid && !(a.loanedAsset === undefined);
    // isValid = isValid && !!a.testingId;
    isValid = isValid && a.inChargeOfEnum != null;
    isValid = isValid && !!a.assetCostCenter?.locationDate;
    isValid = isValid && !!a.assetCostCenter?.costCenter;
    isValid = isValid && !!a.assetCostCenterOrder?.locationDate;
    isValid = isValid && !!a.assetCostCenterOrder?.costCenter;
    // isValid = isValid && !!a.assetCostCenterOrder?.costCenter;
    // isValid = isValid && !!a.assetContract?.contractId;
    return {
      ...a,
      isValid,
    };
  });
  return res;
};
